import { applyMiddleware, compose, createStore } from "redux";
import thunk from "redux-thunk";
import { getAllTexture } from "../Actions/texture";
import { Reducers } from "../Reducers";
import { getQueryParams } from "../utils/utils";

export const store = createStore(Reducers,compose(applyMiddleware(thunk)));

//initialize
let params = getQueryParams();
if (params.query_string_procode && params.query_string_group) {
    store.dispatch(getAllTexture(params));
}else{
    store.dispatch(getAllTexture(params));
}